module.exports = __webpack_public_path__ + "static/media/edek4.fc0ba704.png";